<template lang="html">
    <div v-if="params && params.isActive">
        <ModalDefault size="m" :with-content="true" @close="close();" :theme="true" :fix-height="false" :fix-width="false" :loading="loading">
            <template slot="main">
                <section class="change-access">
                    <p class="modal-title">{{ $trad.changeAccess.title }}</p>
                    <p
                        v-html-safe="
                            $t(params.user.isEnabled ? 'changeAccess.activate' : 'changeAccess.desactivate', { fullName: params.user.fullName })
                        "
                    ></p>
                    <div class="row d-flex justify-content-end">
                        <ClientColorButton :background-color="currentBrand.linksColor" @click="changeAccess();" class="mr-3">{{
                            $t("actions.confirm")
                        }}</ClientColorButton>
                        <ClientColorButton :inactiveColor="true" @click.prevent="close();">{{ $t("actions.cancel") }}</ClientColorButton>
                    </div>
                </section>
            </template>
        </ModalDefault>
    </div>
</template>

<script lang="js">
import connectionBO from '../../../services/connectionBO'
import ModalDefault from "@/components/ui/ModalDefault";
import {mapState} from "vuex";
import historyService from "@/services/history";
import {OBJECT_TYPE, SHORT_DESCRIPTION} from "@/components/history/constants";

export default {
    name: 'change-access',
    components: {ModalDefault},
    props: [
        'params'
    ],
    data () {
        return {
            loading: false
        }
    },
    methods: {
        changeAccess () {
            this.loading = true;
            connectionBO.putAccessUser(this.params.user.id, {isEnabled: this.params.user.isEnabled}).then(response => {
                if (response.code !== 200) {
                    this.loading = false;
                    this.dialogError(response.code, "Code erreur : " + response.code, response.message.message);
                } else {
                    this.loading = false;
                    this.params.isActive = false;
                    this.$emit('loadUsers');
                }
            })
        },
        close() {
            this.params.isActive = false
            this.$emit('resetState', this.params.user);
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"]),
    }
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// ChangeAccess.vue?cbbbe5e0